module.exports = __webpack_public_path__ + "img/gridperson-avatar.ff36c8a9.png";